<div
  bsModal
  [config]="{ ignoreBackdropClick: true, keyboard: false }"
  #modal="bs-modal"
  class="modal-loader modal fade"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="color-blue">Confirmação de Envio ao Veículos Brasil</h4>
      </div>

      <div class="modal-body">
        <div class="text-center">
          <span class="small-icon icon-indicado-pesados-brasil"></span>

          <h2 class="color-blue no-margin">ATENÇÃO</h2>

          <h4>Está proposta será enviada para o Agente:</h4>

          <h4 class="font-orange">
            {{ agenteEndereco?.code }} - {{ agenteEndereco?.name }}
          </h4>
          <h4 class="font-orange">
            {{ agenteEndereco?.address?.city }} -
            {{ agenteEndereco?.address?.state }}
          </h4>
          <h4 class="font-orange">
            Contato: {{ agenteEndereco?.phone?.phoneNumber }} -
            {{ agenteEndereco?.phone?.contactName }}
          </h4>

          <h4 class="color-black">
            <strong>
              Você confirma a indicação e envio para este agente?
            </strong>
          </h4>
        </div>

        <div class="modal-footer">
          <button
            style="margin-left: 0"
            type="button"
            class="btn btn-border-orange pull-left"
            data-dismiss="modal"
            (click)="cancelar()"
          >
            Não, voltar
          </button>
          <button
            style="margin-right: 0"
            type="button"
            class="btn btn-full-orange pull-right"
            (click)="confirmar()"
            data-dismiss="modal"
          >
            Sim, confirmo o envio
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
